import { render, staticRenderFns } from "./SignatureSettings.vue?vue&type=template&id=d10c436e&"
import script from "./SignatureSettings.vue?vue&type=script&lang=js&"
export * from "./SignatureSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports